export default __webpack_public_path__ + "static/media/healthques4.4174dd4f.svg";